import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function KeyboardCommandKeyIcon(props: IconProps) {
    return <Icon {...props} iconKey={"keyboard_command_key"}/>
}
